import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import {
  Box,
  Grid,
  Typography,
  ButtonBase,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import tablet from "../assets/whoweare/icons/tabletFinalIcon.svg";
import mobile from "../assets/whoweare/icons/mobileIcon.svg";
import dongle from "../assets/whoweare/icons/firestickIcon.svg";
import stb from "../assets/whoweare/icons/stbIcon.svg";
import tv from "../assets/whoweare/icons/tvIcon1.svg";
import hbbtv from "../assets/whoweare/icons/hbbtvIcon.svg";
import appleTV from "../assets/whoweare/icons/appleTvIcon.svg";
import computer from "../assets/whoweare/icons/laptopIcon.svg";
import android from "../assets/whoweare/Screenshot_20251229_162621_VZY One-portrait.png";
import iphone from "../assets/whoweare/iphonetpxFinal.png"
import appletv from "../assets/whoweare/appleTvFinal11-removebg-preview.png"
import ipad from "../assets/whoweare/ipadFinalTpx.png";
import appleTvbg from "../assets/whoweare/appleTvFinal11-removebg-preview.png"
import dongleDevice from "../assets/whoweare/Dongle.png";
import appletv2 from "../assets/whoweare/image (1).svg";
import laptop from "../assets/whoweare/laptopFinal.png";
import tvView from "../assets/whoweare/tvTpxFFF-removebg-preview.png";
import setupBox from "../assets/whoweare/stbTVViewFinal-removebg-preview (1).png";
import fire from "../assets/whoweare/Untitled design (5)-Photoroom.png"
import TiltImg from "../components/imageTilted/tiltImage";
import hbbtvImg from "../assets/whoweare/hbbtv7.png"
import AOS from "aos";
import "aos/dist/aos.css";

const images = {
  tv: tvView,
  mobile: android,
  tablet: ipad,
  laptop: laptop,
  dongle: fire,
  stb: setupBox,
  appleTV:iphone,
  hbbtv:hbbtvImg,
  appletv2:appletv
  
  
};

const icons = {
  tv,
  laptop: computer,
  mobile,
  tablet,
  dongle,
  stb,
  appleTV,
  appletv2,
  hbbtv
  
};

const FrontendApp = () => {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("tv");
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleChange = (tab) => {
    setSelectedTab(tab);
  };

  useEffect(() => {
    AOS.init({ duration: 1000, once: false, offset: 100 });
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        background: "black",
        position: "relative",
        overflowX: "hidden",
        py: 4,
      }}
    >
      {/* Blur overlay */}
      <Box
        sx={{
          backdropFilter: "blur(3px)",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
        }}
      />

      <Box sx={{ position: "relative", zIndex: 1, p: 2 }}>
        <Grid container spacing={4} alignItems="center" justifyContent="center">
          {/* LEFT SIDE - Static Image, Device Image, Tabs */}
          <Grid item xs={12} md={6}>
            {/* Static Top Logo/Image */}
            <Box
              data-aos="fade-in"
              sx={{
                display: "flex",
                justifyContent: "center",
                pb: 6,
              }}
            >
              <Box
                component="img"
                src={require("../assets/whoweare/image (2).png")}
                alt="Static"
                sx={{
                  maxWidth: "100%",
                  height: "auto",
                  maxHeight: "100px",
                  objectFit: "contain",
                }}
              />
            </Box>

            {/* Dynamic Device Image */}
            <Box
              data-aos="slide-right"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 2,
                p:3,
                pt:5
              }}
            >
              

  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      maxHeight: { xs: 200, sm: 300, md: 350 },
      width: "100%",
    }}
  >
    <TiltImg img={images[selectedTab]}  h="300px" w={selectedTab === "mobile" ? "150px" : "auto"} />
  </Box>

            </Box>

            {/* Device Tabs */}
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              spacing={2}
              pt={4}
            >
              {Object.entries(icons).map(([key, icon]) => (
                <Grid item key={key}>
<ButtonBase
  onClick={() => handleChange(key)}
  sx={{
    borderRadius: "50%",
    overflow: "hidden",
    border:
      selectedTab === key
        ? "3px solid #1e3a8a"
        : "2px solid transparent",

    background:
      selectedTab === key
        ? "radial-gradient(circle, #1e40af 0%, #0f172a 45%, #000000 100%)"
        : "#999999",

    transition: "all 0.3s ease",

    "&:hover": {
      background:
        "radial-gradient(circle, #1e40af 0%, #0f172a 45%, #000000 100%)",
    },

    width: 64,
    height: 64,
    p: 1,
  }}
>
  <Box
    component="img"
    src={icon}
    alt={key}
    sx={{ width: "100%", height: "100%" }}
  />
</ButtonBase>

                </Grid>
              ))}
            </Grid>
          </Grid>

          {/* RIGHT SIDE - Text Content */}
          <Grid item xs={12} md={6} data-aos="slide-left" sx={{mb:10}}>
            <Box sx={{display:"flex", alignContent:"center",justifyContent:"center"}}>
              <Typography
                    data-aos="zoom-in"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      textAlign:"center",
                      fontSize: "39px",
                      fontWeight: "800",
                      fontFamily: "system-ui",
                      color: "#6054E4",
                      paddingBottom:"40px"
                      
                    }}
                  >
              OTT Frontend Application
            </Typography>
            </Box>
            <Typography
              variant="body1"
              color=" #ffff"
              sx={{
                fontSize: { xs: "0.95rem", sm: "1rem" },
                fontWeight:"800",
                lineHeight: 1.7,
                textAlign: "justify",
              }}
            >
              At Horizon Broadband, we bring nearly a decade of expertise in
              Smart TV app, making us a trusted go-to partner for
              businesses seeking high-quality, scalable solutions. Our team has
              a proven track record of successful deployments, helping clients
              navigate the complexities of the Smart TV app certification
              process to ensure a faster time-to-market. We understand the
              challenges involved in launching apps across multiple Smart TV
              platforms and territories. That’s why our solutions are tailored
              for cross-device compatibility, delivering a seamless and engaging
              user experience across all major Smart TV brands. Whether it’s
              Tizen, webOS, Android TV, or Roku, we specialize in building
              robust, feature-rich applications that align with your business
              goals. Our products supports a wide range of use 
              cases—from entertainment streaming to interactive content
              delivery—ensuring your app meets both functional and performance
              requirements. At Horizon Broadband, we’re passionate about viewer
              engagement, UI/UX excellence, and offering turnkey Smart TV
              solutions that drive results.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default FrontendApp;
